<template>
  <div>
    <div class="cont-xw clearfix">
      <div class="jg-head">产品图片</div>
      <div style="overflow: hidden" class="text-center">
        <div class="text-center">
          <img
            class="form-group col-md-6 col-xs-6 col-sm-6"
            style="float:none"
            src="../../common/images/BU01.jpg"
          />
          <div @click="riseup" class="btn btn-success btn-circle top text-center">上升</div>
          <div>
            <a href="#fast" type="button" class="btn btn-danger btn-circle download text-center">下载</a>
          </div>
        </div>
      </div>
      <div class="jg-head">产品概述</div>
      <p>IVF-BU01第一代UHF蓝牙读卡器是一款便携式小型读卡器，可通过蓝牙接口与ios、android等智能系统平台连接使用，也可以通过USB与电脑连接使用。腕带式设计，同时可选配自拍杆配件轻松就变成帯杆读写器，便于工业应用，改变原来超高频电子标签必须采用专用的读写设备，实现超高频读写器的微型化、低成本化、民用化，推动RFID应用系统工程真正的普及化。</p>
      <div class="jg-head">参数规格</div>
      <p>支持超高频（UHF）标签协议ISO18000-6C</p>
      <p>支持系统：Windows、IOS、Android、Mini Program</p>
      <p>通信接口：BLE4.0、USB</p>
      <p>读取距离：50cm（视标签大小而定）</p>
      <p>工作时长：连续工作3小时，可查询3万次</p>
      <p>材料：ABS+PC工程塑料</p>
      <p>电池容量：500mA</p>
      <p>充电方式：USB 5V/0.5A，充电2小时</p>
      <p>指示灯：电源指示灯、蓝牙指示灯、状态指示灯</p>

      <p>蜂鸣器：内置蜂鸣器</p>

      <p>开关：拨扭开关</p>

      <p>工作环境温度：-20℃~60℃</p>
      <div class="jg-head">指示灯状态</div>
      <p>中间灯:</p>
      <p>①、正常工作：绿灯长亮</p>
      <p>②、设备异常：灯不亮</p>
      <p>③、电 量 低：绿灯一直缓慢闪烁（低电报警，请尽快充电）</p>
      <p>④、电量超低：绿灯一直快速闪烁（低电停止使用，无法读卡）</p>
      <p>⑤、充 电 中：红灯长亮</p>
      <p>⑥、充电完成：红灯灭掉</p>
      <p>左边灯:</p>
      <p>①、蓝牙连接成功：绿灯长亮</p>
      <p>②、蓝牙传输数据：绿灯快闪</p>
      <p>右边灯:</p>
      <p>①、操作标签成功：绿灯闪烁</p>
      <div class="jg-head">产品应用</div>
      <p>产品应用：腕带式手表、伸缩杆式读头、胸挂式阅读器、桌面式读写器。</p>
      <div id="fast" class="jg-head">下载</div>
      <!-- 制作 新的组件 新组件：超链接地址 + download 属性 文本传输 download 判断属性 -->
      <ul>
        <li class="form-group">
          <FileDownload href="/static/IVF-BU/IVF-BU01 产品规格书(通用)-中英文.docx">产品规格书（中英文）</FileDownload>
        </li>
        <li class="form-group">
          <FileDownload href="/static/SDK/BU01_ALL_SDK.zip">BU中性完整SDK下载</FileDownload>
        </li>
        <li class="form-group">
          <QRDownload></QRDownload>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import FileDownload from '@/base/filedownload'
import QRDownload from '@/base/qrdownload'
import { riseup } from "@/common/js/riseup.js";
export default {
  data() {
    return {};
  },
  methods: {

    riseup() {
        riseup()
      }

      
  },
  components: {FileDownload, QRDownload}
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/BU/01.vue